import { Reimbursement } from '../types';

import { hasReimbursementFull } from './reimbursement';

const PRECISE_DOSAGE_FREQUENCY_MIN_VALUE = 1;
const PRECISE_DOSAGE_FREQUENCY_MAX_VALUE = 30;
const HOURS_PER_DAY = 24;

export type PreciseDosageFrequencyValidationOptions = {
   issuedForYear: boolean;
   reimbursement: Reimbursement | null | undefined;
};

export const getPreciseDosageFrequencyMinValue = (): number => {
   return PRECISE_DOSAGE_FREQUENCY_MIN_VALUE;
};

export const getPreciseDosageFrequencyMaxValue = (): number => {
   return PRECISE_DOSAGE_FREQUENCY_MAX_VALUE;
};

export const isPreciseDosageFrequencyValidated = (options: PreciseDosageFrequencyValidationOptions): boolean => {
   return !options.issuedForYear && hasReimbursementFull(options.reimbursement ?? null);
};

export const isPreciseDosageFrequencyAllowed = (frequency: number | null | undefined): boolean => {
   if (!frequency) {
      return true;
   }

   return HOURS_PER_DAY % frequency === 0;
};
